import React from "react";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Pages Calendar
import Calendar from "../pages/Calendar/index";

//Email
import EmailInbox from "../pages/Email/email-inbox";
import EmailRead from "../pages/Email/email-read";
import EmailCompose from "../pages/Email/email-compose";

import Emailtemplatealert from "../pages/EmailTemplate/email-template-alert";
import Emailtemplatebasic from "../pages/EmailTemplate/email-template-basic";
import Emailtemplatebilling from "../pages/EmailTemplate/email-template-billing";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

//  // Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login";
import Login2 from "../pages/AuthenticationInner/Login2";
import Register1 from "../pages/AuthenticationInner/Register";
import Register2 from "../pages/AuthenticationInner/Register2";
import Recoverpw from "../pages/AuthenticationInner/Recoverpw";
import Recoverpw2 from "../pages/AuthenticationInner/Recoverpw2";
import ForgetPwd1 from "../pages/AuthenticationInner/ForgetPassword";
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen";
import LockScreen2 from "../pages/AuthenticationInner/auth-lock-screen-2";
import ConfirmMail from "../pages/AuthenticationInner/page-confirm-mail";
import ConfirmMail2 from "../pages/AuthenticationInner/page-confirm-mail-2";
import EmailVerification from "../pages/AuthenticationInner/auth-email-verification";
import EmailVerification2 from "../pages/AuthenticationInner/auth-email-verification-2";
import TwostepVerification from "../pages/AuthenticationInner/auth-two-step-verification";
import TwostepVerification2 from "../pages/AuthenticationInner/auth-two-step-verification-2";

// Dashboard
import Dashboard from "../pages/Dashboard/index";

// Bookings
import Bookings from "../pages/Bookings/index";
import BookingsDetails from "../pages/Bookings/details";

// Drivers
import Drivers from "../pages/Drivers/index";
import DriversProfile from "../pages/Drivers/details";

// Real-Time Drivers
import RealTimeDrivers from "../pages/RealTimeDrivers/index";

// New Driver Registrations
import NewDriverRegistrations from "../pages/NewDriverRegistrations/index";
import NewDriverRegistrationDetails from "../pages/NewDriverRegistrations/details";

// New Vehicle Registrations
import NewVehicleRegistrations from "../pages/NewVehicleRegistrations/index";
import NewVehicleRegistrationDetails from "../pages/NewVehicleRegistrations/details";

// Customers
import Customers from "../pages/Customers/index";
import CustomerDetails from "../pages/Customers/details";

// Materials
import Materials from "../pages/Materials/index";
import MaterialsCreate from "../pages/Materials/create";
import MaterialsEdit from "../pages/Materials/edit";

// Promotions
import Promotions from "../pages/Promotions/index";
import PromotionsCreate from "../pages/Promotions/create";
import PromotionsEdit from "../pages/Promotions/edit";

// Refferal
import Refferal from "../pages/Refferal/index";
import RefferalCreate from "../pages/Refferal/create";
import RefferalEdit from "../pages/Refferal/edit";

// Discounts
import Discounts from "../pages/Discounts/index";
import DiscountsCreate from "../pages/Discounts/create";
import DiscountsEdit from "../pages/Discounts/edit";

// Garages
import Garage from "../pages/Garages/index";
import GarageCreate from "../pages/Garages/create";
import GarageEdit from "../pages/Garages/edit";

// Nearby Places
import NearbyPlaces from "../pages/NearbyPlaces/index";
import NearbyPlacesCreate from "../pages/NearbyPlaces/create";
import NearbyPlacesEdit from "../pages/NearbyPlaces/edit";

// ContactUs
import ContactUs from "../pages/ContactUs/index";
import ContactUsCreate from "../pages/ContactUs/create";
import ContactUsEdit from "../pages/ContactUs/edit";

// Promo Codes
import PromoCodes from "../pages/PromoCodes/index";
import PromoCodesCreate from "../pages/PromoCodes/create";

// Faqs
import Faqs from "../pages/Faqs/index";
import FaqsCreate from "../pages/Faqs/create";
import FaqsEdit from "../pages/Faqs/edit";

// Vehicles
import Vehicles from "../pages/Vehicles/index";

// Vehicles-Categories
import VehiclesCategories from "../pages/Vehicles-Categories/index";
import VehiclesCategoriesCreate from "../pages/Vehicles-Categories/create";
import VehiclesCategoriesEdit from "../pages/Vehicles-Categories/edit";

// Vehicles-BodyTypes
import VehicleBodyTypes from "../pages/Vehicle-BodyTypes/index";
import VehicleBodyTypesCreate from "../pages/Vehicle-BodyTypes/create";
import VehicleBodyTypesEdit from "../pages/Vehicle-BodyTypes/edit";

// Drivers-Document-Types
import DriversDocumentTypes from "../pages/Drivers-Document-Types/index";
import DriverDocumentsTypesCreate from "../pages/Drivers-Document-Types/create";
import DriverDocumentsTypesEdit from "../pages/Drivers-Document-Types/edit";

// Drivers-Document
import DriversDocument from "../pages/Drivers-Document/index";

// User-Wallet
import UserWallets from "../pages/UserWallets/index";

// Wallet Transactions
import WalletTransactions from "../pages/WalletTransactions/index";

// Wallet Cashout
import WalletCashout from "../pages/WalletCashout/index";

// Driver Top-ups
import DriverTopup from "../pages/DriverTopup/index";

// Anees-Vouchers
import AneesVoucher from "../pages/Anees-Voucher/index";
import AneesVoucherCreate from "../pages/Anees-Voucher/create";

// Vehicles-Document-Types
import VehiclesDocumentTypes from "../pages/Vehicles-Document-Types/index";
import VehicleDocumentsTypesCreate from "../pages/Vehicles-Document-Types/create";
import VehicleDocumentsTypesEdit from "../pages/Vehicles-Document-Types/edit";

// Vehicles-Document
import VehiclesDocument from "../pages/Vehicles-Document/index";

// Charts
import ChartApex from "../pages/Charts/Apexcharts";
import ChartjsChart from "../pages/Charts/ChartjsChart";
import EChart from "../pages/Charts/EChart";
import SparklineChart from "../pages/Charts/SparklineChart";

// Maps
import MapsGoogle from "../pages/Maps/MapsGoogle";
import MapsVector from "../pages/Maps/MapsVector";
import MapsLeaflet from "../pages/Maps/MapsLeaflet";

//Icons
import IconDripicons from "../pages/Icons/IconDripicons";
import IconMaterialdesign from "../pages/Icons/IconMaterialdesign";
import TypiconsIcon from "../pages/Icons/IconTypicons";
import IconIon from "../pages/Icons/IconIon";
import ThemifyIcon from "../pages/Icons/IconThemify";
import IconFontawesome from "../pages/Icons/IconFontawesome";

//Tables
import BasicTables from "../pages/Tables/BasicTables";
import DatatableTables from "../pages/Tables/DatatableTables";
import ResponsiveTables from "../pages/Tables/ResponsiveTables";

// Forms
import FormElements from "../pages/Forms/FormElements";
import FormAdvanced from "../pages/Forms/FormAdvanced";
import FormEditors from "../pages/Forms/FormEditors";
import FormValidations from "../pages/Forms/FormValidations";
import FormMask from "../pages/Forms/FormMask";
import FormRepeater from "../pages/Forms/FormRepeater";
import FormUpload from "../pages/Forms/FormUpload";
import FormWizard from "../pages/Forms/FormWizard";

//Ui
import UiAlert from "../pages/Ui/UiAlert";
import UiButtons from "../pages/Ui/UiButtons";
import UiCards from "../pages/Ui/UiCards";
import UiCarousel from "../pages/Ui/UiCarousel";
import UiColors from "../pages/Ui/UiColors";
import UiDropdown from "../pages/Ui/UiDropdown";
import UiGeneral from "../pages/Ui/UiGeneral";
import UiGrid from "../pages/Ui/UiGrid";
import UiImages from "../pages/Ui/UiImages";
import UiLightbox from "../pages/Ui/UiLightbox";
import UiModal from "../pages/Ui/UiModal";
import UiProgressbar from "../pages/Ui/UiProgressbar";
import UiTabsAccordions from "../pages/Ui/UiTabsAccordions";
import UiTypography from "../pages/Ui/UiTypography";
import UiVideo from "../pages/Ui/UiVideo";
import UiSessionTimeout from "../pages/Ui/UiSessionTimeout";
import UiRating from "../pages/Ui/UiRating";
import UiUtilities from "pages/Ui/UiUtilities";
import UiOffcanvas from "pages/Ui/UiOffcanvas";

//Pages
import PagesStarter from "../pages/Utility/pages-starter";
import PagesMaintenance from "../pages/Utility/pages-maintenance";
import PagesComingsoon from "../pages/Utility/pages-comingsoon";
import PagesTimeline from "../pages/Utility/pages-timeline";
import PagesInvoice from "../pages/Utility/PagesInvoice";
import PagesFaqs from "../pages/Utility/pages-faqs";
import PagesPricing from "../pages/Utility/pages-pricing";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";
import PagesGallery from "../pages/Utility/PagesGallery";
import PagesDirectory from "../pages/Utility/PagesDirectory";
import PagesProfile from "pages/Utility/pages-profile";
import FuelReward from "pages/Fuel-Reward";
import FuelRewardSetting from "pages/Fuel-Reward-Setting";
import BookingRadiusSetting from "pages/Booking-Radius-Setting";
import AppVersionSettings from "pages/App-Version-Settings";
import OTPProviderSettings from "pages/OTP-Provider-Settings";
import Tracking from "pages/Tracking";
import Waste from "pages/Waste";
import WasteTypeCreate from "pages/Waste/create";
import WasteTypeEdit from "pages/Waste/edit";
import AssignDriver from "pages/Tracking/AssignDriver";

const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },

  // //Bookings
  { path: "/bookings", component: <Bookings /> },
  { path: "/bookings/:id", component: <BookingsDetails /> },

  // //Real-Time Drivers
  { path: "/real-time-drivers", component: <RealTimeDrivers /> },

  // //New Driver Registrations
  { path: "/new-driver-registrations", component: <NewDriverRegistrations /> },
  { path: "/new-driver-registrations/:driverId", component: <NewDriverRegistrationDetails /> },

  // //New Vehicle Registrations
  { path: "/new-vehicle-registrations", component: <NewVehicleRegistrations /> },
  { path: "/new-vehicle-registrations/:vehicleId", component: <NewVehicleRegistrationDetails /> },

  // //Drivers
  { path: "/drivers", component: <Drivers /> },
  { path: "/drivers/:id", component: <DriversProfile /> },

  // //Customers
  { path: "/customers", component: <Customers /> },
  { path: "/customers/:id", component: <CustomerDetails /> },

  // //Materials
  { path: "/materials", component: <Materials /> },
  { path: "/materials/create", component: <MaterialsCreate /> },
  { path: "/materials/edit/:id", component: <MaterialsEdit /> },

  // //Promotions
  { path: "/promotions", component: <Promotions /> },
  { path: "/promotions/create", component: <PromotionsCreate /> },
  { path: "/promotions/edit/:id", component: <PromotionsEdit /> },

  // //Refferal
  { path: "/refferals", component: <Refferal /> },
  { path: "/refferals/create", component: <RefferalCreate /> },
  { path: "/refferals/edit/:id", component: <RefferalEdit /> },

  // //ContactUs
  { path: "/contact-us", component: <ContactUs /> },
  { path: "/contact-us/create", component: <ContactUsCreate /> },
  { path: "/contact-us/edit/:id", component: <ContactUsEdit /> },

  // //Discounts
  { path: "/discounts", component: <Discounts /> },
  { path: "/discounts/create", component: <DiscountsCreate /> },
  { path: "/discounts/edit/:id", component: <DiscountsEdit /> },

  // //Fuel Rewards
  { path: "/fuel-reward", component: <FuelReward/>},
  { path: "/fuel-reward-setting", component: <FuelRewardSetting/>},
  { path: "/booking-radius-settings", component: <BookingRadiusSetting/>},

  // //Promo Codes
  { path: "/promo-codes", component: <PromoCodes /> },
  { path: "/promo-codes/create", component: <PromoCodesCreate /> },
  
  // //Tracking
  { path: "/waste", component: <Waste /> },
  { path: "/waste/create", component: <WasteTypeCreate /> },
  { path: "/waste/edit/:id", component: <WasteTypeEdit /> },

  // //Vehicles
  { path: "/vehicles", component: <Vehicles /> },

  // //Tracking
  { path: "/tracking", component: <Tracking /> },
  { path: "/assign-driver/:id", component: <AssignDriver /> },

  // //User-Wallet
  { path: "/user-wallets", component: <UserWallets /> },

  // //Wallet Transactions
  { path: "/wallet-transactions", component: <WalletTransactions /> },

  // //Wallet Cashout
  { path: "/wallet-cashout", component: <WalletCashout /> },

  // //Driver Topups
  { path: "/drivers-topups", component: <DriverTopup /> },

  // //Faqs
  { path: "/faqs", component: <Faqs /> },
  { path: "/faqs/create", component: <FaqsCreate /> },
  { path: "/faqs/edit/:id", component: <FaqsEdit /> },

  // //App Version Settings
  { path: "/app-version-settings", component: <AppVersionSettings /> },
  { path: "/otp-provider-settings", component: <OTPProviderSettings /> },

  // //Garages
  { path: "/garages", component: <Garage /> },
  { path: "/garages/create", component: <GarageCreate /> },
  { path: "/garages/edit/:id", component: <GarageEdit /> },

  // //Nearby Places
  { path: "/nearby-places", component: <NearbyPlaces /> },
  { path: "/nearby-places/create", component: <NearbyPlacesCreate /> },
  { path: "/nearby-places/edit/:id", component: <NearbyPlacesEdit /> },

  // //Vehicle Body-Types
  { path: "/vehicles-bodytypes", component: <VehicleBodyTypes /> },
  { path: "/vehicles-bodytypes/create", component: <VehicleBodyTypesCreate /> },
  { path: "/vehicles-bodytypes/edit/:id", component: <VehicleBodyTypesEdit /> },

  // //Anees-Vouchers
  { path: "/anees-vouchers", component: <AneesVoucher /> },
  { path: "/anees-vouchers/create", component: <AneesVoucherCreate /> },

  // //Vehicles Categories
  { path: "/vehicles-categories", component: <VehiclesCategories /> },
  { path: "/vehicles-categories/create", component: <VehiclesCategoriesCreate /> },
  { path: "/vehicles-categories/edit/:id", component: <VehiclesCategoriesEdit /> },

  // //Document (Drivers)
  { path: "/drivers-documents", component: <DriversDocument /> },

  // //Document Types (Drivers)
  { path: "/drivers-documents-types", component: <DriversDocumentTypes /> },
  { path: "/drivers-documents-types/create", component: <DriverDocumentsTypesCreate /> },
  { path: "/drivers-documents-types/edit/:id", component: <DriverDocumentsTypesEdit /> },

  // //Vehicles (Vehicles)
  { path: "/vehicles-documents", component: <VehiclesDocument /> },

  // //Vehicles Types (Vehicles)
  { path: "/vehicles-documents-types", component: <VehiclesDocumentTypes /> },
  { path: "/vehicles-documents-types/create", component: <VehicleDocumentsTypesCreate /> },
  { path: "/vehicles-documents-types/edit/:id", component: <VehicleDocumentsTypesEdit /> },

  // //calendar
  { path: "/calendar", component: <Calendar /> },

  // //profile
  { path: "/profile", component: <UserProfile /> },

  //Email
  { path: "/email-inbox", component: <EmailInbox /> },
  { path: "/email-read", component: <EmailRead /> },
  { path: "/email-compose", component: <EmailCompose /> },

  // Email Template
  { path: "/email-template-alert", component: <Emailtemplatealert /> },
  { path: "/email-template-basic", component: <Emailtemplatebasic /> },
  { path: "/email-template-billing", component: <Emailtemplatebilling /> },

  //Charts
  { path: "/apex-charts", component: <ChartApex /> },
  { path: "/chartjs-charts", component: <ChartjsChart /> },
  { path: "/e-charts", component: <EChart /> },
  { path: "/sparkline-charts", component: <SparklineChart /> },

  // Icons
  { path: "/icons-dripicons", component: <IconDripicons /> },
  { path: "/icons-materialdesign", component: <IconMaterialdesign /> },
  { path: "/icons-fontawesome", component: <IconFontawesome /> },
  { path: "/icons-ion", component: <IconIon /> },
  { path: "/icons-themify", component: <ThemifyIcon /> },
  { path: "/icons-typicons", component: <TypiconsIcon /> },

  // Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-datatable", component: <DatatableTables /> },
  { path: "/tables-responsive", component: <ResponsiveTables /> },

  // Maps
  { path: "/maps-google", component: <MapsGoogle /> },
  { path: "/maps-vector", component: <MapsVector /> },
  { path: "/maps-leaflet", component: <MapsLeaflet /> },

  // Forms
  { path: "/form-elements", component: <FormElements /> },
  { path: "/form-advanced", component: <FormAdvanced /> },
  { path: "/form-editors", component: <FormEditors /> },
  { path: "/form-mask", component: <FormMask /> },
  { path: "/form-repeater", component: <FormRepeater /> },
  { path: "/form-uploads", component: <FormUpload /> },
  { path: "/form-wizard", component: <FormWizard /> },
  { path: "/form-validation", component: <FormValidations /> },

  // Ui
  { path: "/ui-alerts", component: <UiAlert /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-dropdowns", component: <UiDropdown /> },
  { path: "/ui-general", component: <UiGeneral /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-lightbox", component: <UiLightbox /> },
  { path: "/ui-modals", component: <UiModal /> },
  { path: "/ui-progressbars", component: <UiProgressbar /> },
  { path: "/ui-tabs-accordions", component: <UiTabsAccordions /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-video", component: <UiVideo /> },
  { path: "/ui-session-timeout", component: <UiSessionTimeout /> },
  { path: "/ui-rating", component: <UiRating /> },
  { path: "/ui-utilities", component: <UiUtilities /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },
  
  //Utility
  { path: "/pages-starter", component: <PagesStarter /> },
  { path: "/pages-timeline", component: <PagesTimeline /> },
  { path: "/pages-invoice", component: <PagesInvoice /> },
  { path: "/pages-directory", component: <PagesDirectory /> },
  { path: "/pages-faqs", component: <PagesFaqs /> },
  { path: "/pages-pricing", component: <PagesPricing /> },
  { path: "/pages-gallery", component: <PagesGallery /> },
  { path: "/pages-profile", component: <PagesProfile /> },

  // this route should be at the end of all other routes
  { path: "/", component: <Dashboard /> },

];

const authRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },

  { path: "/pages-maintenance", component: <PagesMaintenance /> },
  { path: "/pages-comingsoon", component: <PagesComingsoon /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },

  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-login-2", component: <Login2 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/pages-register-2", component: <Register2 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/page-recoverpw-2", component: <Recoverpw2 /> },
  { path: "/pages-forgot-pwd", component: <ForgetPwd1 /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  { path: "/auth-lock-screen-2", component: <LockScreen2 /> },
  { path: "/page-confirm-mail", component: <ConfirmMail /> },
  { path: "/page-confirm-mail-2", component: <ConfirmMail2 /> },
  { path: "/auth-email-verification", component: <EmailVerification /> },
  { path: "/auth-email-verification-2", component: <EmailVerification2 /> },
  { path: "/auth-two-step-verification", component: <TwostepVerification /> },
  { path: "/auth-two-step-verification-2", component: <TwostepVerification2 /> },
];

export { userRoutes, authRoutes };
